import {
  Component, OnInit, ViewContainerRef, ComponentFactoryResolver, ViewChild, HostListener, HostBinding, Output,
  EventEmitter,
} from '@angular/core';
import {IModalContainer, ModalOptions} from '../modal-container.interface';
import {BLACK_CROSS_DATA_URL, WHITE_CROSS_DATA_URL} from '../modal-close-button.config';

@Component({
  selector: 'spb-primary-modal',
  templateUrl: './primary-modal.component.html',
  styleUrls: ['./primary-modal.component.scss'],
})

export class PrimaryModalComponent implements OnInit, IModalContainer {
  @HostBinding('class.spb-primary-modal') hostBaseClass = true;
  @ViewChild('modalContentSibling', {read: ViewContainerRef}) modalContentSibling: ViewContainerRef;

  closeButtonDataUrl: any;
  isModalVisible = false;
  modalComponent: IModalContainer;
  options: ModalOptions;
  overlay = 'rgba(255, 255, 255, 0.5 )';
  private currentComponent: any;
  @Output() modalCloseEvent: EventEmitter<any> = new EventEmitter();

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    this.registerModalComponent(this);
  }

  registerModalComponent(modalComponent: IModalContainer) {
    this.modalComponent = modalComponent;
  }

  showModal(modalContent: any, data: any, options: ModalOptions): void {
    if (!this.isModalVisible) {
      if (options && options.overlay) {
        this.overlay = options.overlay;
      }

      if (options.showWhiteCloseButton) {
        this.closeButtonDataUrl = WHITE_CROSS_DATA_URL;
      } else {
        this.closeButtonDataUrl = BLACK_CROSS_DATA_URL;
      }
      this.updateBodyScroll(true);
      this.isModalVisible = true;
      this.insertModalContent(modalContent, data);
      this.options = options;
    }
  }

  updateBodyScroll(modalOpen: boolean) {
    const body = document.body;
    body.classList.toggle('stop-body-scroll', modalOpen);
  }

  hideModal(): void {
    this.isModalVisible = false;
    this.updateBodyScroll(false);
    this.removeCurrentComponent();
    this.modalCloseEvent.emit(true);
  }

  insertModalContent(modalContent: any, data: any) {
    if (this.modalContentSibling) {
      const factory = this.componentFactoryResolver.resolveComponentFactory(modalContent);
      const ref = this.modalContentSibling.createComponent(factory);
      ref.instance['data'] = data;
      ref.changeDetectorRef.detectChanges();
      this.removeCurrentComponent();
      this.currentComponent = ref;
    }
  }

  removeCurrentComponent() {
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyup(event: any) {
    if (event.keyCode === 27 && (this.options && this.options.escClose)) {
      this.hideModal();
    }
  }

}
